import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ConfigurationPanel from './ConfigurationPanel'

const Dashboard: React.FC = () => {
  return (
    <SectionWrapper title="common.label.dashboard">
      <ConfigurationPanel />
    </SectionWrapper>
  )
}

export default Dashboard
